import { defineMessages } from 'react-intl-next';

export const messages: {
	autocompleteSuggestion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	autocompleteSuggestion: {
		id: 'search_dialog_autocomplete_suggestion',
		defaultMessage: 'Suggestion',
		description: 'Label for autocomplete suggestions',
	},
});
